import React from "react";
import {Paper} from "@mui/material";
import {EnterNewPasswordMFAProps, TotpToken} from "./types";
import {Controller, FormProvider, useForm} from "react-hook-form";
import {LoadingButton} from "@mui/lab";
import ErrorBanner from "../../common/ErrorBanner";
import MfaDeviceLostButton from "../../common/MfaDeviceLostButton";
import ForgottenPasswordCancelLink from "./ForgottenPasswordCancelLink";

import {FORGOT_PASSWORD_FORM_TRANSLATION} from "./ForgotPasswordForm.translation.de";
import {useLxTranslations} from "@lxo-blocks/react";
import {TotpCodeFormInput} from "../authenticate/mfa/totp/components/TotpCodeFormInput";

export default function EnterNewPasswordMFAForm(enterNewPasswordMFAProps: EnterNewPasswordMFAProps) {

  const {t} = useLxTranslations(FORGOT_PASSWORD_FORM_TRANSLATION);

  const formMethods = useForm<TotpToken>({
    mode: "all",
    defaultValues: {
      totptoken: ""
    }
  });
  const {handleSubmit, formState, control} = formMethods;
  const {isSubmitting, errors} = formState;


  return (
    <>
      <Paper sx={{px: 8, py: 5}}>
        {enterNewPasswordMFAProps.currentError.length > 0 && (
          <ErrorBanner headline={t("PASSWORD_RESET_ERROR_HEADLINE")}
                       description={enterNewPasswordMFAProps.currentError.length > 0
                         ? enterNewPasswordMFAProps.currentError
                         : ""}
                       sx={{mb: 3}}/>)}
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(enterNewPasswordMFAProps.submitMethod)}>
            <Controller
              control={control}
              name="totptoken"
              rules={{required: t("MFA_CODE_REQUIRED").toString()}}
              render={(props: any) => <TotpCodeFormInput {...props} sx={{mb: 3}}/>}/>

            <LoadingButton
              sx={{py: 1}}
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              disabled={!!errors.totptoken}
              loading={isSubmitting}
              loadingPosition="end"
              endIcon={<></>}
            >
              {isSubmitting
                ? t("ENTER_NEW_PASSWORD_AND_LOGIN_IS_SUBMITTING")
                : t("ENTER_NEW_PASSWORD_AND_LOGIN")}
            </LoadingButton>
          </form>
        </FormProvider>

        <MfaDeviceLostButton onResetMfa={enterNewPasswordMFAProps.successHandler.onMfaReset} sx={{pt: 3, pb: 1}}/>
      </Paper>
      <ForgottenPasswordCancelLink sx={{pt: 3, pb: 1}}/>
    </>
  )
    ;
}
